import { render, staticRenderFns } from "./charts_keyword.vue?vue&type=template&id=a6034132&scoped=true"
import script from "./charts_keyword.vue?vue&type=script&lang=js"
export * from "./charts_keyword.vue?vue&type=script&lang=js"
import style0 from "./charts_keyword.vue?vue&type=style&index=0&id=a6034132&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6034132",
  null
  
)

export default component.exports